import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import {  Observable, Subscription } from 'rxjs';

import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';

import { FullProfileAnimationModel } from '@Core/Dialogs/models/full-profile-animation.model';
import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';

import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { DateAndValueXYChart } from '@Common/Charts/models/date-and-value-x-y.chart';
import { PositiveNegativeRiverChartModel } from '@Common/Charts/models/PositiveNegativeRiverChart/positive-negative-river-chart.model';
import { AlertsSurgeChartService } from '@Monitor/Alerts/services/alerts-surge-chart.service';
import { MonitoringBackEndDataSourceModel } from '@Monitor/Shared/models/monitoring-back-end-data-source.model';
import { MultiSeriesDateAndValueXYChart } from '@Common/Charts/models/multi-series-date-and-value-x-y.chart';

import { AlertSurgeMetricEnum } from '@Monitor/Alerts/enums/alert-surge-metric.enum';

@Component({
    selector: 'agpr-alert-surge-sensitivity-dialog',
    templateUrl: './alert-surge-sensitivity-dialog.component.html',
    styleUrls: ['./alert-surge-sensitivity-dialog.component.scss'],
    animations: [
        trigger('panelState', [
            state('hidden', style({
                opacity: 0,
                transform: 'scaleY(0)'
            })),
            state('visible', style({
                opacity: 1,
                transform: 'scaleY(1)'
            })),
            transition('visible => hidden', animate('.1s linear')),
            transition('hidden => visible', animate('.15s cubic-bezier(0, 0, 0.2, 1)'))
        ])
    ],
    standalone: false
})
export class AlertSurgeSensitivityDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {
    @Input() overlayContainer: Element;
    @Input() animationTrigger: Observable<FullProfileAnimationModel>;
    @Input() title: string = '';
    @Input() metric: AlertSurgeMetricEnum;
    @Input() sensitivity: number;
    @Input() selectedSource: MonitoringBackEndDataSourceModel;

    readonly minPanelWidth = 980;
    readonly maxPanelWidth = 1600;
    readonly buttonTypes = ButtonTypesEnum;

    hideSlideOverlay: boolean = false;

    chart: PositiveNegativeRiverChartModel | DateAndValueXYChart | MultiSeriesDateAndValueXYChart;

    loading: boolean = true;

    subscriptions: Subscription[] = [];

    constructor(
        coreDialogService: CoreDialogService,
        private alertsSurgeChartService: AlertsSurgeChartService,
    ) {
        super(coreDialogService, 'AlertSurgeSensitivityDialog');
    }

    ngOnInit() {
        this.loading = true;
        this.alertsSurgeChartService.setChartYValueLabel(`Alerts.surge.metrics.${this.metric}`);
        this.alertsSurgeChartService.generateChart(this.metric, this.sensitivity, this.selectedSource);
        this.subscriptions.push(
            this.alertsSurgeChartService.getChart().subscribe(chart => {
                this.chart = chart;
                this.loading = false;
            })
        );
    }

    ngOnDestroy(): void {
        this.alertsSurgeChartService.setAlertHistory(null);
        this.alertsSurgeChartService.destroyOldChart();
        this.subscriptions.forEach((sub) => sub.unsubscribe());
        this.subscriptions = [];
    }

    panelOpened() {
        // do nothing for now (can probably remove but keeping it incase for future)
    }
    close() {
        this.closeDialog();
    }

}
